import { canUseDOM } from 'exenv';

require('react').PropTypes = require('prop-types');

// https://gist.github.com/gaearon/9a4d54653ae9c50af6c54b4e0e56b583#javascript-environment-requirements
if (!canUseDOM) {
  global.requestAnimationFrame = function raf(callback) {
    setTimeout(callback, 0);
  };
}
